export default "__VITE_ASSET__thOtQ080__"